<template>
  <DotLottieVue ref="Service0" class="size-[200px] lg:size-[15vw]" autoplay :src="props.src" />
</template>

<script setup>
const props = defineProps({
  src: {
    type: String,
    default: "",
  },
})

const Service0 = ref();

const initiateInterval = () => {
  setInterval(() => {
    if (Service0.value && import.meta.client) {
      const lottieInstance = Service0.value.getDotLottieInstance()
      lottieInstance.play()
    }
  }, 9000)
}

onMounted(() => {
  nextTick(() => {
    initiateInterval()
  })
})
</script>
